import {Api} from "../api/api";

const timezone = async () => {
  const userNameElement = document.querySelector(`.js-current-user-name`);

  const TIME_ZONE_KEY = `timezone`;


  const getTimeZone = () => {
    const timezone = new Date().getTimezoneOffset() / 60;
    return timezone <= 0 ? Math.abs(timezone) : 0 - timezone;
  };

  const saveTimeZoneToLocalStorage = (timezone) => {
    localStorage.setItem(TIME_ZONE_KEY, timezone);
  };

  const getTimeZoneFromLocalStorage = () => {
    return Number(localStorage.getItem(TIME_ZONE_KEY));
  };

  if (userNameElement) {
    const timezone = getTimeZone();
    const currentTimeZone = getTimeZoneFromLocalStorage();

    const backendApi = new Api();

    if (!currentTimeZone || currentTimeZone !== timezone) {
      const res = await backendApi.customQuery(`/profile/set-timezone?timeZone=${timezone}`, {});

      if (res.code === 200) {
        saveTimeZoneToLocalStorage(timezone);
      }
    }
  }
};

export {timezone};
